import { NO_QUOTE } from "MODULES/IncomingQuotes/constants";

export const AVG_OVERHAUL = "avg_overhaul";
export const AVG_REPAIR = "avg_repair";
export const AVG_TEST = "avg_test";
export const AWAITING_REPLY = "awaiting_reply";
export const BER_RATE = "ber_rate";
export const EVALUATION_FEE = "evaluation_fee";
export const QUOTE_TYPE = "quote_type";
export const NO_CAPES = "no_capes";
export const REPAIR_QUOTE_LINE_ITEM = "repair_quote_line_item";
export const STANDARD = "standard";
export const OVERHAUL_TAT = "overhaul_tat";
export const REPAIR_TAT = "repair_tat";
export const TEST_TAT = "test_tat";
export const TURNAROUND_TIME = "turnaround_time";
export const QUOTE_TYPES = [NO_CAPES, AWAITING_REPLY, STANDARD];
export const QUOTE_TYPES_ABBREV = {
  [NO_QUOTE]: "NQ",
  [NO_CAPES]: "NoCapes",
  [AWAITING_REPLY]: "Awaiting",
  [STANDARD]: "Std"
};



// WEBPACK FOOTER //
// ./app/modules/RepairQuotes/constants.jsx